import Vue from 'vue';
import store from "@/store";
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const defaultLanguage = store.getLanguage() || 'pt-BR';
store.setLanguage(defaultLanguage);

const dateTimeFormats = {
    'en-US': {
        short: {
            year: 'numeric', month: 'numeric', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'
        }
    },
    'pt-BR': {
        short: {
            day: 'numeric', month: 'numeric', year: 'numeric'
        },
        long: {
            day: 'numeric', month: 'numeric', year: 'numeric',
            hour: 'numeric', minute: 'numeric',
            hour12: false
        }
    }
}

const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency',
            currency: 'USD'
        },
        currencyNoCents: {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    },
    'pt-BR': {
        currency: {
            style: 'currency',
            currency: 'BRL'
        },
        currencyNoCents: {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    },
}


const ptBR = require('./pt_br.json');
const enUS = require('./en.json');
const messages = {'pt-BR': ptBR, 'en-US': enUS};

export default new VueI18n({
    locale: defaultLanguage,
    fallbackLocale: defaultLanguage,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
});